// extracted by mini-css-extract-plugin
export var brandTagline = "ServicePlans-module--brand-tagline--e64a6";
export var currentFeature = "ServicePlans-module--current-feature--0f087";
export var currentPlan = "ServicePlans-module--current-plan--34cea";
export var feature = "ServicePlans-module--feature--ac91f";
export var featureDescription = "ServicePlans-module--featureDescription--c85d4";
export var featureRow = "ServicePlans-module--featureRow--1f21f";
export var featureTitle = "ServicePlans-module--featureTitle--f9266";
export var header = "ServicePlans-module--header--f2a12";
export var highlighted = "ServicePlans-module--highlighted--98539";
export var highlightedHU = "ServicePlans-module--highlightedHU--a44c7";
export var navigationButton = "ServicePlans-module--navigation-button--f0364";
export var navigationButtonActive = "ServicePlans-module--navigation-button-active--86440";
export var navigationContainer = "ServicePlans-module--navigation-container--61a54";
export var navigationOffset = "ServicePlans-module--navigation-offset--bdebb";
export var nextPlan = "ServicePlans-module--next-plan--9f3ef";
export var placeholderHeading = "ServicePlans-module--placeholderHeading--2ae2c";
export var planAfterNextPlan = "ServicePlans-module--plan-after-next-plan--3582e";
export var planBeforePreviousPlan = "ServicePlans-module--plan-before-previous-plan--3ca45";
export var planContainer = "ServicePlans-module--plan-container--5abf3";
export var planName = "ServicePlans-module--plan-name--95876";
export var planTitleContainer = "ServicePlans-module--plan-title-container--c35cd";
export var previousPlan = "ServicePlans-module--previous-plan--8e088";
export var striked = "ServicePlans-module--striked--15c85";
export var subFeature = "ServicePlans-module--sub-feature--679d7";
export var subFeatureDescription = "ServicePlans-module--subFeatureDescription--873a3";
export var subFeatureTitle = "ServicePlans-module--subFeatureTitle--16345";
export var subtitle = "ServicePlans-module--subtitle--0cffb";
export var table = "ServicePlans-module--table--1d016";
export var targetAudienceLabel = "ServicePlans-module--target-audience-label--67b89";